import { createGlobalStyle } from "styled-components";
const Global=createGlobalStyle`
body{
    background: white;
    color:black;
    overflow-x: hidden;
    margin:0;
    padding:0;
    overflow-x: hidden;
}
h2 span{ 
    
    color:#8B73FF;
}

` 
export default Global;